import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import { SubscribePublicKeyRes, SubscribeReq, SubscribeRes, UnsubscribeReq } from "./types";

export const getPublicKey = (): AxiosPromise<SubscribePublicKeyRes> =>
    axiosInstance.post(`/push/public-key`);

export const subscribe = (
    params: SubscribeReq
  ): AxiosPromise<SubscribeRes> =>
    axiosInstance.post(`/push/subscribe`, params);

export const unsubscribe = (
    params: UnsubscribeReq
    ): AxiosPromise =>
    axiosInstance.post(`/push/unsubscribe`, params);